import { z } from 'zod';
/**
 * Bot (machine) principals.
 *
 * A bot is created by an org admin and given an X25519 public key generated in
 * the admin's browser — the secret half is shown once and never reaches the
 * server. Everything a bot posts is ciphertext, exactly as for a human member.
 */
/** base64 X25519 public key, 32 bytes -> 44 chars with padding. */
const publicKeyB64 = z
    .string()
    .regex(/^[A-Za-z0-9+/]{43}=$/, 'publicKey must be a base64-encoded 32-byte key');
export const createBotSchema = z.object({
    displayName: z.string().min(1).max(80),
    /** Public half of the bot's keypair. Generated client-side. */
    publicKey: publicKeyB64,
    /** Optional first credential name, so creation can return a usable key. */
    keyName: z.string().min(1).max(120).optional(),
});
export const issueBotKeySchema = z.object({
    name: z.string().min(1).max(120),
    /** Days until the credential stops working. Omit for a non-expiring key. */
    expiresInDays: z.number().int().min(1).max(730).optional(),
});
/**
 * Param schemas must list EVERY path param on the route.
 *
 * `validate(schema, 'params')` reassigns `req.params` to the parsed result, so
 * any param omitted here is silently dropped before the handler reads it.
 */
export const botIdParamSchema = z.object({
    orgId: z.string().uuid(),
    botId: z.string().uuid(),
});
export const botKeyParamSchema = z.object({
    orgId: z.string().uuid(),
    botId: z.string().uuid(),
    keyId: z.string().uuid(),
});
//# sourceMappingURL=bot.schema.js.map